/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectSearch_viewer$ref = any;
export type SbSharedRefineMenuFilterCreator_viewer$ref = any;
export type SbSharedRefineMenuFilterCreator_viewer = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectSearch_viewer$ref;
    readonly " $refType": SbSharedRefineMenuFilterCreator_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterCreator_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '0e18e5187b12e17e380593bb93529af4';
export default node;
